"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asAnd = exports.JoinCondition = exports.JoinType = void 0;
const condition_1 = require("./condition");
const Model = __importStar(require("./index"));
const _ = __importStar(require("lodash"));
const list_condition_1 = require("./list-condition");
var JoinType;
(function (JoinType) {
    JoinType[JoinType["OR"] = 0] = "OR";
    JoinType[JoinType["AND"] = 1] = "AND";
})(JoinType || (exports.JoinType = JoinType = {}));
class JoinCondition extends condition_1.Condition {
    constructor() {
        super("Group Condition");
        this.joinType = JoinType.AND;
        this.conditions = [];
        this.negate = false;
        this.setDepth(1);
    }
    add(conditionType) {
        let ConditionModel = Model[conditionType];
        let newCondition = new ConditionModel();
        newCondition.setDepth(this.depth + 1);
        if (newCondition instanceof list_condition_1.ListCondition) {
            newCondition.condition.setDepth(this.depth + 1);
        }
        this.conditions.push(newCondition);
        return newCondition;
    }
    set(conditions) {
        _.map(conditions, (c) => {
            c.setDepth(this.depth + 1);
            return c;
        });
        this.conditions = conditions;
    }
    addCondition(condition) {
        condition.setDepth(this.depth + 1);
        if (condition instanceof list_condition_1.ListCondition) {
            condition.condition.setDepth(this.depth + 1);
        }
        this.conditions.push(condition);
    }
    remove(condition) {
        _.remove(this.conditions, (c) => c === condition);
    }
}
exports.JoinCondition = JoinCondition;
function asAnd(...conditions) {
    let joinCondition = new JoinCondition();
    joinCondition.conditions = conditions;
    return joinCondition;
}
exports.asAnd = asAnd;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/casa-rules-v2/join-condition.js
// module id = 1242
// module chunks = 0